import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useQuery } from "@tanstack/react-query";

export function getInmarIntegrationQueryKey() {
  return ["inmarIntegration"] as const;
}

export function useInmarIntegrationQuery() {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);

  return useQuery({
    queryKey: getInmarIntegrationQueryKey(),
    queryFn: async () => {
      return await rpcClient.getInmarIntegration({});
    },
    enabled: !!rpcClient,
    staleTime: 30_000,
  });
}
